/*
 * @Description: 
 * @Version: 2.0
 * @Autor: 一诺(丘汉文)
 * @Date: 2020-04-13 10:29:20
 * @Author: 一诺(丘汉文)
 * @LastEditors: 一诺(丘汉文)
 */
export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center" */ '../views/login/login.vue')
  },
  {
    path: '/login/resetPassword',
    name: 'resetPassword',
    meta: {
      title: '修改密码'
    },
    component: () => import(/* webpackChunkName: "example-configuration-center" */ '../views/login/resetPassword.vue')
  }
]
